/* eslint-disable react/prop-types */
import React from "react";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { useFormApi } from "../useForm";
import FormError from "./FormError";
import FormInfo from "./FormInfo";
import "./FormControl.scss";
/**
 * Wrapper for a custom form control. Use the other form controls for ready to use inputs.
 */
const LabeledControl = React.forwardRef(({ id, className, langKey, label, info = false, required = false, disabled = false, children, }, ref) => {
    const { langSet } = useFormApi();
    const t = useTranslate(langSet);
    if (!langKey)
        langKey = id;
    return (React.createElement("div", { ref: ref, className: `aui-form-control ${className !== null && className !== void 0 ? className : ""} ${disabled ? "disabled" : ""}` },
        label !== null && (React.createElement("label", { htmlFor: id },
            label || t(langKey + "Label"),
            " ",
            !required && React.createElement("span", { className: "optional" },
                "(",
                t("optional"),
                ")"))),
        children,
        React.createElement(FormError, { id: id }),
        React.createElement(FormInfo, { info: info, t: t, langKey: langKey })));
});
LabeledControl.displayName = "LabeledControl";
export default LabeledControl;
